'use strict';
define([
    'angular',
    'modules/settings/invoices/invoices.controller',
], function (angular, InvoicesController) {
    var app = angular.module('settings.invoices', []);
    app.controller('InvoicesController', InvoicesController);
    return app;
});
